import {
  ACCESS_INFO_ACTIONS,
  ACCESS_INFO_SECTIONS,
  useProjectDataContext,
  useProjectSecurityContext,
} from 'domain/shared/newProject';
import { useCustomerReports } from './hooks/useCustomerReports';
import RecipientsContext from './List/RecipientsList/RecipientsContext';
import { ShowSection } from 'framework/ui/layout';
import { Loading } from 'framework/ui/mui-builder';
import ReportContext from './List/ReportList/ReportContext';

const CustomerReportContext = () => {
  const { data } = useProjectDataContext();
  const { isAccessGranted } = useProjectSecurityContext();
  const { data: reportsData, refetch, isDataReloading } = useCustomerReports(data?.id);

  if (isDataReloading || !reportsData) {
    return (
      <ShowSection sx={{ '&.section-details__wrapper': { p: '0px !important' } }}>
        <Loading isInitialPosition />
      </ShowSection>
    );
  }

  return (
    <>
      {data?.settings?.reportSettings?.isSystemReportUsed &&
        isAccessGranted(ACCESS_INFO_SECTIONS.RECIPIENT, ACCESS_INFO_ACTIONS.VIEW) && (
          <RecipientsContext projectId={data.id} reportRecipients={reportsData.reportRecipients} />
        )}
      <ReportContext customerReports={reportsData.customerReports} refetch={refetch} />
    </>
  );
};
export default CustomerReportContext;
